import { FieldProps } from "formik";
import React, { useRef, useState } from "react";
import { Button, Icon } from "../../..";

type TextInputTypes = "text" | "email" | "number";

export interface TextInputProps<T = any> {
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	innerRef?: React.RefObject<T>;
	id: string;
	name: string;
	onKeyPress?: (e: React.KeyboardEvent) => void;
	ref?: React.RefObject<any>;
	type?: TextInputTypes;
	value?: string;
	[key: string]: any;
	editInline?: boolean;
	className?: string;
	copyable?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
	type = "text",
	field,
	form,
	className,
	editInline,
	id,
	name,
	innerRef,
	copyable = false,
	...props
}) => {
	const [copied, setCopied] = useState(false);
	const textAreaRef = useRef<HTMLTextAreaElement>(null);
	const copyToClipboard = (e: any) => {
		e.stopPropagation();
		e.preventDefault();
		if (textAreaRef && textAreaRef.current) {
			textAreaRef.current.select();
			document.execCommand("copy");
			// This is just personal preference.
			// I prefer to not show the whole text area selected.
			e.target.focus();
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 3000);
		}
	};

	if (form?.status?.bag?.readonly) {
		return <div className="form-readonly-value">{(field && field.value) || props.value || ""}</div>;
	}
	return (
		<>
			<input
				id={id}
				type={type}
				{...field}
				ref={innerRef}
				name={(field && field.name) || name}
				value={(field && field.value) || props.value || ""}
				className={`${className ? className : ""}${editInline ? "edit-inline" : ""}`}
				{...props}
			/>
			{copyable && (
				<div className="input-copy-wrap">
					<Button onClick={copyToClipboard} classes="input-copy-button" purpose="plain" title="Copy Text">
						<Icon icon={copied ? "check" : "copy"} />
						{copied && <span className="m-left-sm">Copied!</span>}
					</Button>
					<textarea
						ref={textAreaRef}
						value={(field && field.value) || props.value || ""}
						className="hidden"
					/>
				</div>
			)}
		</>
	);
};

export default TextInput;
